<template>
    <div class="rank-container">
        <div class="header">
            <div class="title">事件排名</div>
            <CardTabs :data="['日', '周', '月']" 
                :TabsStyle="TabsStyle" 
                @changed="dateChanged"
                :checked="time">
            </CardTabs>
        </div>
        <div class="content-loading" v-if="status === 'loading'" v-loading="status === 'loading'">
            
        </div>
        <div class="content-loading" v-else-if="status === 'error'">
            error
        </div>
        <div class="content" v-else>
            <RankList :rankData="data" :popoverData="popoverData" :time="time"
                @showPopover="showPopover"
                @closePopover="closePopover">    
            </RankList>
        </div>
    </div>
</template>

<script>
import RankList from './rank/RankList';
import CardTabs from './shared/CardTabs';

export default {
    props: {
        popoverData:Object,
        data: {
            type: Array,
        },
        time: {
            type: Number,
            default: 0,
        },
        status: String
    },
    data () {
        return {
            TabsStyle: {
                // width: '121rem'
            },
        }
    },
    methods: {
        dateChanged: function (index) {
            this.$emit('changed', index);
        },
        showPopover: function (mouseEvent, id) {
            // console.log(window);
            // console.log(mouseEvent);
            // console.log(id)
            this.$emit('showPopover', mouseEvent, id)
        },
        closePopover: function () {
            this.$emit('closePopover');
        }
    },
    components: {
        RankList,
        CardTabs
    },
}
</script>

<style lang="less" scoped>
.rank-container {
    .h(440);
    .w(796);
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 16px 0px rgba(0, 43, 102, 0.04);
    display: flex;
    flex-direction: column;

    overflow: hidden;

    .header {
        display: flex;
        justify-content: space-between;
        padding-left: 24rem;
        padding-right: 24rem;
        height: 64rem;
        line-height: 64rem;

        .title {
            font-size: 18rem;
            font-weight: bold;
            color: #333333;
        }
    }

    .content-loading {
        display: flex;
        justify-content: center;
        align-items: center;
        flex: 1;
    }

    .content {
        flex: 1;
    }
}
</style>